import React, { useState, useEffect } from "react";
import { Container, Row, Col, Form, Button, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import DeploymentProgressModal from "./DeploymentProgressModal";

// Redux
import { DatabaseCreate, DatabaseGetTypes, DatabaseGetVersions } from "../../services/ReduxTookit/Slice/DatabaseRedux";

// Images
import homeImage from "../../assets/images/home.svg";

// Database Type Icons Component
const DatabaseTypeIcon = ({ type, size = 40 }) => {
    const icons = {
        postgresql: (
            <svg width={size} height={size} viewBox="0 0 128 128">
                <path fill="#336791" d="M93.81 28.9c-6.65-3.78-14.07-5.73-21.67-5.73-2.66 0-5.33.21-7.91.62-.22.04-.43.08-.65.12-.15.02-.31.05-.46.07-5.7.97-10.91 3.02-15.45 6.04-2.79 1.86-5.3 4.08-7.47 6.59a37.4 37.4 0 0 0-5.7 8.38c-.53 1.01-1.01 2.04-1.44 3.1-.43 1.04-.81 2.1-1.14 3.18-.66 2.14-1.12 4.35-1.38 6.61a41.5 41.5 0 0 0-.21 4.19v.54c.01.92.05 1.83.12 2.74.15 1.86.44 3.69.87 5.47.22.93.48 1.84.78 2.74.3.9.64 1.78 1.02 2.65.76 1.72 1.67 3.37 2.73 4.92.53.78 1.1 1.53 1.7 2.26.6.72 1.24 1.42 1.91 2.08.67.67 1.38 1.3 2.11 1.9.74.6 1.51 1.17 2.31 1.7l.09.06c.64.43 1.3.83 1.98 1.2.58.32 1.18.62 1.79.89.12.06.25.11.37.17.07.03.14.06.22.09.14.06.29.12.43.18v16.98l-.04 3.64c-.02 2.12-.04 4.24-.04 6.37 0 2.48.48 4.84 1.35 7.03.88 2.2 2.18 4.18 3.82 5.82s3.62 2.94 5.82 3.82c2.2.88 4.56 1.36 7.04 1.36 2.48 0 4.84-.48 7.04-1.36 2.2-.88 4.18-2.18 5.82-3.82s2.94-3.62 3.82-5.82c.87-2.19 1.35-4.55 1.35-7.03V99.5c0-1.13-.01-2.26-.02-3.38-.01-1.58-.03-3.16-.03-4.74v-2.43c1.68-.68 3.3-1.5 4.85-2.45 2.22-1.37 4.28-3 6.14-4.85 1.86-1.85 3.51-3.92 4.88-6.14.4-.64.77-1.31 1.12-1.98.35-.68.68-1.37.98-2.08.6-1.4 1.1-2.86 1.49-4.35a30.52 30.52 0 0 0 .93-8.72c-.06-1.52-.21-3.02-.46-4.5-.25-1.48-.6-2.93-1.05-4.35-.45-1.41-.99-2.79-1.63-4.12-.64-1.33-1.36-2.61-2.17-3.83-1.61-2.43-3.55-4.63-5.74-6.53-2.19-1.9-4.63-3.51-7.23-4.78z"/>
                <ellipse fill="#fff" cx="64" cy="64" rx="14" ry="18"/>
                <circle fill="#336791" cx="64" cy="60" r="6"/>
            </svg>
        ),
        mysql: (
            <svg width={size} height={size} viewBox="0 0 128 128">
                <path fill="#00618a" d="M116.948 97.807c-6.863-.187-12.104.452-16.585 2.341-1.273.537-3.305.552-3.513 2.147.7.733.807 1.822 1.365 2.717 1.07 1.71 2.876 4.002 4.495 5.197 1.768 1.306 3.593 2.696 5.525 3.745 3.426 1.866 7.25 2.93 10.53 4.799 1.934 1.102 3.857 2.491 5.72 3.742.932.628 1.556 1.604 2.696 2.028v-.235c-.62-.79-1.03-1.85-1.71-2.58-1.065-1.141-2.307-2.147-3.548-3.092-3.681-2.793-8.153-5.237-12.538-7.163-3.324-1.462-7.46-2.422-10.53-3.787-1.109-.492-2.951-.763-3.51-1.748 1.397-1.452 2.413-3.432 3.548-5.164 2.154-3.279 4.241-6.87 6.068-10.398 1.058-2.042 1.77-4.111 3.105-5.946-1.67-.207-3.513-.453-5.328-.55-2.332-.126-4.84-.053-7.042.55-.556 1.44.397 2.917.55 4.367.16 1.47.075 2.953.393 4.367.62 2.746 1.607 5.428 2.717 7.944 1.216 2.757 2.62 5.454 4.095 7.944.709 1.196 1.79 3.006 2.716 3.787-.58.567-1.002.842-1.366 1.517-1.138 2.106-1.179 4.68-1.592 7.376-.623.107-1.038-.553-1.517-.942-2.37-1.93-4.235-4.906-5.719-7.566-3.898-6.981-7.242-14.64-10.377-22.22-1.165-2.816-1.915-5.59-2.912-8.34-.387-1.065-.33-2.651-1.108-3.288-1.023 1.554-2.552 2.818-3.355 4.623-1.285 2.887-1.455 6.41-1.94 9.999-2.89-.755-3.91-3.72-5.033-6.244-2.856-6.422-3.378-16.742.157-23.873 .908-1.831 3.077-7.589 2.086-9.294-.497-1.577-2.135-2.499-3.044-3.744-1.128-1.544-2.259-3.574-3.044-5.359-2.048-4.655-3.063-9.861-5.318-14.67-1.055-2.25-2.838-4.534-4.324-6.557-1.649-2.242-3.49-3.898-4.781-6.557-.458-.944-.682-2.36-1.365-2.941h-.785c-.974 2.254-.212 5.052.39 7.338.757 2.89 1.437 5.883 2.52 8.556 1.101 2.719 2.181 5.477 3.554 8.008.719 1.326 3.044 2.097 3.289 3.744-1.834 2.577-1.968 6.588-3.014 9.859-2.362 7.377-1.468 16.538 1.957 21.992 1.052 1.675 3.528 5.258 6.854 3.876 2.91-1.21 2.261-4.96 3.092-8.293.187-.752.072-1.307.432-1.82v.157l2.563 5.126c1.9 3.055 5.268 6.24 8.046 8.38 1.442 1.11 2.577 3.029 4.411 3.744v-.235h-.157c-.362-.58-.929-.819-1.436-1.26-1.184-1.032-2.507-2.311-3.438-3.509-2.721-3.5-5.125-7.339-7.28-11.261-.987-1.794-1.845-3.772-2.641-5.632-.305-.713-.3-1.79-.864-2.175-0.8 1.246-1.98 2.256-2.563 3.744-0.93 2.375-1.05 5.276-1.383 8.282-.203.013-.113.006-.235.078-2.047-.494-2.768-2.597-3.549-4.367-1.977-4.481-2.345-11.702-.625-16.887.445-1.342 2.455-5.57 1.653-6.827-.39-1.278-1.685-2.019-2.408-3.023-0.888-1.232-1.775-2.855-2.408-4.25-1.645-3.627-2.426-7.688-4.173-11.337-.836-1.743-2.253-3.507-3.398-5.127-1.27-1.796-2.685-3.123-3.667-5.283-.348-.764-.82-1.984-.314-2.825.159-.528.387-.707.863-.864z"/>
            </svg>
        ),
        mongodb: (
            <svg width={size} height={size} viewBox="0 0 128 128">
                <path fill="#47a248" d="M64 1.5c-34.8 0-63 28.2-63 63s28.2 63 63 63 63-28.2 63-63-28.2-63-63-63zm0 116c-29.2 0-53-23.8-53-53s23.8-53 53-53 53 23.8 53 53-23.8 53-53 53z"/>
                <path fill="#47a248" d="M64 28.5c-2.6 0-5 2.1-5 5v59c0 2.8 2.2 5 5 5s5-2.2 5-5v-59c0-2.9-2.4-5-5-5z"/>
                <ellipse fill="#47a248" cx="64" cy="100" rx="8" ry="5"/>
            </svg>
        ),
        redis: (
            <svg width={size} height={size} viewBox="0 0 128 128">
                <path fill="#dc382d" d="M121.8 93.1c-6.7 3.5-41.4 17.7-48.8 21.6-7.4 3.9-11.5 3.8-17.3 1S13.8 97.5 7.1 94.1c-3.3-1.7-5.1-3.2-5.1-4.6V75c0 0 47.4-10.3 55.4-13.4 8-3.1 10.8-3.2 17.3-.3 6.5 2.9 46.4 9.6 53.2 12.3v14.6c0 1.4-1.8 3-6.1 4.9z"/>
                <path fill="#a41e11" d="M121.8 78.6c-6.7 3.5-41.4 17.7-48.8 21.6-7.4 3.9-11.5 3.8-17.3 1S13.8 83 7.1 79.6c-6.7-3.4-6.9-5.8-.1-8.5 6.8-2.7 45.4-17.7 53.4-20.8 8-3.1 10.8-3.2 17.3-.3 6.5 2.9 39.7 15.6 46.5 18.3 6.9 2.7 4.3 5.8-2.4 10.3z"/>
                <path fill="#dc382d" d="M121.8 68.9c-6.7 3.5-41.4 17.7-48.8 21.6-7.4 3.9-11.5 3.8-17.3 1S13.8 73.3 7.1 69.9c-3.3-1.7-5.1-3.2-5.1-4.6V50.8c0 0 47.4-10.3 55.4-13.4 8-3.1 10.8-3.2 17.3-.3 6.5 2.9 46.4 9.6 53.2 12.3v14.6c0 1.4-1.8 3-6.1 4.9z"/>
            </svg>
        ),
        sqlserver: (
            <svg width={size} height={size} viewBox="0 0 128 128">
                <path fill="#CC292B" d="M64 12C33.1 12 8 22.7 8 36v56c0 13.3 25.1 24 56 24s56-10.7 56-24V36c0-13.3-25.1-24-56-24z"/>
                <ellipse fill="#E83B3E" cx="64" cy="36" rx="48" ry="16"/>
                <path fill="#B22224" d="M16 60c8.5 7.7 27.6 13 48 13s39.5-5.3 48-13v14c0 13.3-25.1 24-56 24S8 87.3 8 74V60c2.4 2.2 5.1 4.2 8 6z"/>
                <path fill="#8F1719" d="M16 84c8.5 7.7 27.6 13 48 13s39.5-5.3 48-13v14c0 13.3-25.1 24-56 24S8 111.3 8 98V84c2.4 2.2 5.1 4.2 8 6z"/>
            </svg>
        ),
        mssql: (
            <svg width={size} height={size} viewBox="0 0 128 128">
                <path fill="#CC292B" d="M64 12C33.1 12 8 22.7 8 36v56c0 13.3 25.1 24 56 24s56-10.7 56-24V36c0-13.3-25.1-24-56-24z"/>
                <ellipse fill="#E83B3E" cx="64" cy="36" rx="48" ry="16"/>
                <path fill="#B22224" d="M16 60c8.5 7.7 27.6 13 48 13s39.5-5.3 48-13v14c0 13.3-25.1 24-56 24S8 87.3 8 74V60c2.4 2.2 5.1 4.2 8 6z"/>
                <path fill="#8F1719" d="M16 84c8.5 7.7 27.6 13 48 13s39.5-5.3 48-13v14c0 13.3-25.1 24-56 24S8 111.3 8 98V84c2.4 2.2 5.1 4.2 8 6z"/>
            </svg>
        ),
        mariadb: (
            <svg width={size} height={size} viewBox="0 0 128 128">
                <rect width="128" height="128" rx="20" fill="#003545"/>
                <path fill="#C07158" d="M84.5 35c-2.8-4.2-7.5-7-12.8-7-8.8 0-16 7.2-16 16 0 2.2.5 4.3 1.3 6.2-7.8 2.2-14.3 7.8-17.8 15.2-4.2 8.8-3.8 19.2 1.1 27.6 4.9 8.4 13.8 13.8 23.5 14.5 1.5.1 3 .1 4.5 0 9.8-.7 18.6-6.2 23.4-14.7 4.8-8.5 5.1-18.9.8-27.7-1.8-3.7-4.4-6.9-7.5-9.4 1.3-3.1 1.5-6.6.6-9.8-.7-2.6-2.1-4.9-4.1-6.7l-3 4.8c1.3 1.2 2.2 2.7 2.6 4.4.6 2.2.4 4.5-.5 6.6l-1.5 3.5 3.5 1.7c4 1.9 7.2 5 9.3 8.9 3.5 6.5 3.3 14.4-.6 20.7-3.9 6.3-10.7 10.3-18.1 10.8-1.2.1-2.4.1-3.6 0-7.3-.6-14-4.5-17.7-10.8-3.7-6.3-4-14.1-.7-20.7 2.8-5.6 7.9-9.8 14-11.4l3.8-1-1.4-3.7c-1.1-2.8-1.2-5.9-.2-8.7 1.4-4 4.8-7.1 9-8 4.2-.9 8.5.5 11.4 3.7l4.3-4z"/>
                <circle fill="#FFFFFF" cx="72" cy="42" r="3.5"/>
            </svg>
        ),
    };

    return icons[type] || icons.postgresql;
};

// Step Indicator Component
const StepIndicator = ({ currentStep, totalSteps = 3 }) => {
    const steps = [
        { num: 1, label: "Select Engine" },
        { num: 2, label: "Configuration" },
        { num: 3, label: "Resources & Review" },
    ];

    return (
        <div className="create-db-step-indicator">
            {steps.map((step, index) => (
                <React.Fragment key={step.num}>
                    <div className={`step-item ${currentStep >= step.num ? "active" : ""} ${currentStep > step.num ? "completed" : ""}`}>
                        <div className="step-circle">
                            {currentStep > step.num ? (
                                <svg width="14" height="14" viewBox="0 0 16 16" fill="currentColor">
                                    <path d="M13.78 4.22a.75.75 0 010 1.06l-7.25 7.25a.75.75 0 01-1.06 0L2.22 9.28a.75.75 0 011.06-1.06L6 10.94l6.72-6.72a.75.75 0 011.06 0z"/>
                                </svg>
                            ) : (
                                step.num
                            )}
                        </div>
                        <span className="step-label">{step.label}</span>
                    </div>
                    {index < steps.length - 1 && <div className={`step-line ${currentStep > step.num ? "completed" : ""}`} />}
                </React.Fragment>
            ))}
        </div>
    );
};

// Default ports for database types
const defaultPorts = {
    postgresql: 5432,
    mysql: 3306,
    mongodb: 27017,
    redis: 6379,
    mssql: 1433,
    sqlserver: 1433,
    mariadb: 3306,
};

// Resource Options
const storageSizes = [10, 20, 50, 100, 200, 500];
const ramSizes = [1, 2, 4, 8, 16, 32];
const cpuOptions = [1, 2, 4, 8];

function CreateDatabase() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    
    // Get database types and versions from Redux store
    const databaseState = useSelector(state => state.databaseredux) || {};
    const { databaseTypes: apiDatabaseTypes = [], databaseVersions = {} } = databaseState;

    // Current step (1, 2, or 3)
    const [currentStep, setCurrentStep] = useState(1);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [errors, setErrors] = useState({});
    const [isLoadingTypes, setIsLoadingTypes] = useState(true);
    
    // Deployment Modal State
    const [showDeploymentModal, setShowDeploymentModal] = useState(false);
    const [deployedDatabaseId, setDeployedDatabaseId] = useState(null);

    // Form Data
    const [formData, setFormData] = useState({
        // Step 1 - Engine Selection
        type: "",
        version: "",

        // Step 2 - Configuration
        name: "",
        dbName: "appdb",
        dbUsername: "dbadmin",
        dbPassword: "",
        dbPort: 5432,
        maxConnections: 100,

        // Step 3 - Resources
        storageSize: 20,
        ramSize: 2,
        cpuCores: 1,
        environment: "production",
        project: "",
    });
    
    // Reserved usernames that can't be used (PostgreSQL system users)
    const RESERVED_USERNAMES = ["pg_admin", "postgres", "root", "superuser", "replication", "pg_monitor", "pg_read_all_data", "pg_write_all_data", "mariadb_admin"];

    // Fetch database types on mount
    useEffect(() => {
        const fetchTypes = async () => {
            setIsLoadingTypes(true);
            await dispatch(DatabaseGetTypes());
            setIsLoadingTypes(false);
        };
        fetchTypes();
    }, [dispatch]);

    // Set default type when types are loaded
    useEffect(() => {
        if (apiDatabaseTypes && apiDatabaseTypes.length > 0 && !formData.type) {
            const availableType = apiDatabaseTypes.find(t => t.available);
            if (availableType) {
                setFormData(prev => ({
                    ...prev,
                    type: availableType.id,
                    dbPort: defaultPorts[availableType.id] || 5432
                }));
                // Fetch versions for the default type
                dispatch(DatabaseGetVersions(availableType.id));
            }
        }
    }, [apiDatabaseTypes, dispatch, formData.type]);

    // Set default version when versions are loaded for the selected type
    useEffect(() => {
        const versions = databaseVersions[formData.type];
        if (versions && versions.length > 0 && !formData.version) {
            const defaultVersion = versions.find(v => v.isDefault) || versions[0];
            setFormData(prev => ({
                ...prev,
                version: defaultVersion.version
            }));
        }
    }, [databaseVersions, formData.type, formData.version]);

    // Get selected database type config
    const selectedDbType = apiDatabaseTypes?.find((db) => db.id === formData.type);
    
    // Get versions for selected type
    const availableVersions = databaseVersions[formData.type] || [];

    // Handle input change
    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));

        // Clear error for this field
        if (errors[name]) {
            setErrors((prev) => ({ ...prev, [name]: null }));
        }
    };

    // Handle database type selection
    const handleTypeSelect = (type) => {
        const dbType = apiDatabaseTypes?.find((db) => db.id === type);
        if (dbType && dbType.available) {
            setFormData((prev) => ({
                ...prev,
                type,
                version: "", // Will be set when versions are loaded
                dbPort: defaultPorts[type] || 5432,
            }));
            // Fetch versions for the selected type
            dispatch(DatabaseGetVersions(type));
        }
    };

    // Password validation
    const validatePassword = (password) => {
        const errors = [];
        if (password.length < 8) errors.push("At least 8 characters");
        if (!/[A-Z]/.test(password)) errors.push("One uppercase letter (A-Z)");
        if (!/[a-z]/.test(password)) errors.push("One lowercase letter (a-z)");
        if (!/[0-9]/.test(password)) errors.push("One digit (0-9)");
        return errors;
    };

    const passwordErrors = validatePassword(formData.dbPassword);
    const isPasswordValid = formData.dbPassword.length > 0 && passwordErrors.length === 0;

    // Validate current step
    const validateStep = (step) => {
        const newErrors = {};

        if (step === 2) {
            // Instance name validation - lowercase, numbers, hyphens only
            if (!formData.name.trim()) {
                newErrors.name = "Instance name is required";
            } else if (!/^[a-z][a-z0-9-]*$/.test(formData.name)) {
                newErrors.name = "Must start with lowercase letter. Only lowercase letters, numbers, and hyphens allowed";
            } else if (formData.name.length > 50) {
                newErrors.name = "Instance name must be 50 characters or less";
            }

            // Database name validation - alphanumeric and underscore only
            if (!formData.dbName.trim()) {
                newErrors.dbName = "Database name is required";
            } else if (!/^[a-zA-Z][a-zA-Z0-9_]*$/.test(formData.dbName)) {
                newErrors.dbName = "Must start with a letter. Only letters, numbers, and underscores allowed";
            } else if (formData.dbName.length > 63) {
                newErrors.dbName = "Database name must be 63 characters or less";
            }

            // Username validation - no reserved names
            if (!formData.dbUsername.trim()) {
                newErrors.dbUsername = "Username is required";
            } else if (RESERVED_USERNAMES.includes(formData.dbUsername.toLowerCase())) {
                newErrors.dbUsername = `"${formData.dbUsername}" is a reserved username. Please choose a different name`;
            } else if (!/^[a-zA-Z][a-zA-Z0-9_]*$/.test(formData.dbUsername)) {
                newErrors.dbUsername = "Must start with a letter. Only letters, numbers, and underscores allowed";
            } else if (formData.dbUsername.length > 63) {
                newErrors.dbUsername = "Username must be 63 characters or less";
            }

            if (!formData.dbPassword) {
                newErrors.dbPassword = "Password is required";
            } else if (passwordErrors.length > 0) {
                newErrors.dbPassword = `Missing: ${passwordErrors.join(", ")}`;
            }
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // Navigate steps
    const goToNextStep = () => {
        if (validateStep(currentStep)) {
            setCurrentStep((prev) => Math.min(prev + 1, 3));
        }
    };

    const goToPrevStep = () => {
        setCurrentStep((prev) => Math.max(prev - 1, 1));
    };

    // Handle form submission - real API
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateStep(currentStep)) {
            return;
        }

        setIsSubmitting(true);

        try {
            const portValue = formData.dbPort || defaultPorts[formData.type] || 5432;

            // Calculate tier based on resources if not explicitly set
            const calculatedTier = formData.tier || (
                (formData.ramSize >= 8 || formData.cpuCores >= 4) ? "large" :
                (formData.ramSize >= 4 || formData.cpuCores >= 2) ? "medium" : "small"
            );

            const tagsData = {};
            if (formData.project && formData.project.trim()) {
                tagsData.project = formData.project.trim();
            }

            const apiData = {
                name: formData.name,
                type: formData.type || "postgresql",
                version: formData.version || "16",
                tier: calculatedTier,
                database: formData.dbName || "appdb",
                username: formData.dbUsername,
                password: formData.dbPassword,
                port: Number(portValue),
                storage: `${formData.storageSize || 20}Gi`,
                environment: formData.environment || "development",
                tags: tagsData,
                resources: {
                    ram: formData.ramSize || 2,
                    cpu: formData.cpuCores || 1,
                },
                input_data: {
                    db_name: formData.dbName || "appdb",
                    db_username: formData.dbUsername,
                    db_password: formData.dbPassword,
                    db_port: String(portValue),
                    storage_size: `${formData.storageSize || 20}Gi`,
                    max_connections: String(formData.maxConnections || 100),
                    ram_gb: String(formData.ramSize || 2),
                    cpu_cores: String(formData.cpuCores || 1),
                },
            };


            const result = await dispatch(DatabaseCreate(apiData));

 
            
            setIsSubmitting(false);

            if (result?.payload?.isValidate) {
                const createdDb = result?.payload?.data?.data;

                setDeployedDatabaseId(createdDb?.id || null);
                setShowDeploymentModal(true);
  
            } else {
           
                toast.error(result?.payload?.data?.message || result?.payload?.message || "Failed to create database");
            }
        } catch (error) {
            console.error("Error creating database:", error);
            setIsSubmitting(false);
            toast.error(error?.message || "Failed to create database");
        }
    };

    // Handle deployment complete
    const handleDeploymentComplete = (data) => {
    
    };

    // Navigate to database detail
    const handleViewDatabase = () => {
        setShowDeploymentModal(false);
        navigate(`/database/${deployedDatabaseId}`);
    };

    // Calculate estimated cost (dummy)
    const estimatedCost = {
        hourly: (formData.ramSize * 0.01 + formData.cpuCores * 0.02 + formData.storageSize * 0.001).toFixed(3),
        monthly: ((formData.ramSize * 0.01 + formData.cpuCores * 0.02 + formData.storageSize * 0.001) * 730).toFixed(2),
    };

    return (
        <div className="create-database-page database-page-main schedular-page-main all-page-top">
            <Container>
                {/* Header */}
                <div className="top-bot-section flex-column align-items-start gap-3">
                    <div className="d-flex justify-content-between align-items-center w-100">
                        <h6>
                            <img
                                src={homeImage}
                                alt="home"
                                title="home"
                                style={{ cursor: "pointer", marginBottom: "3px" }}
                                onClick={() => navigate("/")}
                            />
                            <span style={{ fontWeight: "400", color: "#666666" }}>{" | "}</span>
                            <span
                                onClick={() => navigate("/database")}
                                style={{ cursor: "pointer", color: "#666666" }}
                            >
                                Database Instances
                            </span>
                            <span style={{ fontWeight: "400", color: "#666666" }}>{" | "}</span>
                            <span className="mt-1">Create Database</span>
                        </h6>
                    </div>
                </div>
            </Container>

            {/* Main Content */}
            <div className="main-page-content">
                <Container>
                    {/* Step Indicator */}
                    <StepIndicator currentStep={currentStep} />

                    {/* Form Content */}
                    <div className="create-db-form-container">
                        <Form onSubmit={handleSubmit}>
                            {/* ==================== STEP 1: Select Engine ==================== */}
                            {currentStep === 1 && (
                                <div className="create-db-step-content">
                                    <div className="step-title">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                            <ellipse cx="12" cy="5" rx="9" ry="3"/>
                                        <path d="M3 5v7c0 1.66 4.03 3 9 3s9-1.34 9-3V5"/>
                                        <path d="M3 12v7c0 1.66 4.03 3 9 3s9-1.34 9-3v-7"/>
                                    </svg>
                                    Select Database Engine
                                </div>

                                <div className="db-type-grid">
                                    {isLoadingTypes ? (
                                        <div className="text-center p-4">
                                            <Spinner animation="border" size="sm" /> Loading database types...
                                        </div>
                                    ) : (apiDatabaseTypes || []).map((db) => (
                                        <div
                                            key={db.id}
                                            className={`db-type-card ${formData.type === db.id ? "selected" : ""} ${!db.available ? "disabled" : ""}`}
                                            onClick={() => handleTypeSelect(db.id)}
                                        >
                                            <div className="db-type-icon">
                                                <DatabaseTypeIcon type={db.id} size={48} />
                                            </div>
                                            <div className="db-type-name">{db.name}</div>
                                            <div className="db-type-desc">{db.description}</div>
                                            {!db.available && <div className="db-type-badge">Coming Soon</div>}
                                            {formData.type === db.id && db.available && (
                                                <div className="db-type-check">
                                                    <svg width="20" height="20" viewBox="0 0 16 16" fill="currentColor">
                                                        <path d="M13.78 4.22a.75.75 0 010 1.06l-7.25 7.25a.75.75 0 01-1.06 0L2.22 9.28a.75.75 0 011.06-1.06L6 10.94l6.72-6.72a.75.75 0 011.06 0z"/>
                                                    </svg>
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>

                                <Row className="mt-4">
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Version</Form.Label>
                                            <Form.Select
                                                name="version"
                                                value={formData.version}
                                                onChange={handleInputChange}
                                                disabled={availableVersions.length === 0}
                                            >
                                                {availableVersions.length === 0 ? (
                                                    <option value="">Loading versions...</option>
                                                ) : (
                                                    availableVersions.map((v) => (
                                                        <option key={v.version} value={v.version}>
                                                            {v.displayName || `${selectedDbType?.name || ''} ${v.version}`} {v.isDefault ? "(Default)" : ""}
                                                        </option>
                                                    ))
                                                )}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <div className="step-actions">
                                    <Button variant="outline-secondary" onClick={() => navigate("/database")}>
                                        Cancel
                                    </Button>
                                    <Button variant="primary" onClick={goToNextStep}>
                                        Continue
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" className="ms-2">
                                            <path fillRule="evenodd" d="M4.646 1.646a.5.5 0 01.708 0l6 6a.5.5 0 010 .708l-6 6a.5.5 0 01-.708-.708L10.293 8 4.646 2.354a.5.5 0 010-.708z"/>
                                        </svg>
                                    </Button>
                                </div>
                            </div>
                        )}

                        {/* ==================== STEP 2: Configuration ==================== */}
                        {currentStep === 2 && (
                            <div className="create-db-step-content">
                                <div className="step-title">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <circle cx="12" cy="12" r="3"/>
                                        <path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-2 2 2 2 0 01-2-2v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83 0 2 2 0 010-2.83l.06-.06a1.65 1.65 0 00.33-1.82 1.65 1.65 0 00-1.51-1H3a2 2 0 01-2-2 2 2 0 012-2h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 010-2.83 2 2 0 012.83 0l.06.06a1.65 1.65 0 001.82.33H9a1.65 1.65 0 001-1.51V3a2 2 0 012-2 2 2 0 012 2v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 0 2 2 0 010 2.83l-.06.06a1.65 1.65 0 00-.33 1.82V9a1.65 1.65 0 001.51 1H21a2 2 0 012 2 2 2 0 01-2 2h-.09a1.65 1.65 0 00-1.51 1z"/>
                                    </svg>
                                    Database Configuration
                                </div>

                                <Row>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Instance Name *</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="name"
                                                value={formData.name}
                                                onChange={handleInputChange}
                                                placeholder="e.g., production-db"
                                                isInvalid={!!errors.name}
                                                autoFocus
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.name}
                                            </Form.Control.Feedback>
                                            <Form.Text className="text-muted">
                                                A unique name for your database instance
                                            </Form.Text>
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Database Name *</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="dbName"
                                                value={formData.dbName}
                                                onChange={handleInputChange}
                                                placeholder="e.g., appdb"
                                                isInvalid={!!errors.dbName}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.dbName}
                                            </Form.Control.Feedback>
                                            <Form.Text className="text-muted">
                                                Initial database to create
                                            </Form.Text>
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Master Username *</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="dbUsername"
                                                value={formData.dbUsername}
                                                onChange={handleInputChange}
                                                placeholder="e.g., admin"
                                                isInvalid={!!errors.dbUsername}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.dbUsername}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Master Password *</Form.Label>
                                            <Form.Control
                                                type="password"
                                                name="dbPassword"
                                                value={formData.dbPassword}
                                                onChange={handleInputChange}
                                                placeholder="Enter strong password"
                                                isInvalid={!!errors.dbPassword}
                                                isValid={isPasswordValid}
                                            />
                                            {errors.dbPassword ? (
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.dbPassword}
                                                </Form.Control.Feedback>
                                            ) : isPasswordValid ? (
                                                <Form.Control.Feedback type="valid">
                                                    Password meets all requirements ✓
                                                </Form.Control.Feedback>
                                            ) : (
                                                <Form.Text className="text-muted">
                                                    8+ chars, uppercase (A-Z), lowercase (a-z), digit (0-9)
                                                </Form.Text>
                                            )}
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Port</Form.Label>
                                            <Form.Control
                                                type="number"
                                                name="dbPort"
                                                value={formData.dbPort}
                                                onChange={handleInputChange}
                                                disabled={formData.type === "postgresql"}
                                            />
                                            {formData.type === "postgresql" && (
                                                <Form.Text className="text-muted">
                                                    PostgreSQL uses the default port (5432)
                                                </Form.Text>
                                            )}
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Max Connections</Form.Label>
                                            <Form.Control
                                                type="number"
                                                name="maxConnections"
                                                value={formData.maxConnections}
                                                onChange={handleInputChange}
                                                min={10}
                                                max={1000}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <div className="step-actions">
                                    <Button variant="outline-secondary" onClick={goToPrevStep}>
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" className="me-2">
                                            <path fillRule="evenodd" d="M11.354 1.646a.5.5 0 010 .708L5.707 8l5.647 5.646a.5.5 0 01-.708.708l-6-6a.5.5 0 010-.708l6-6a.5.5 0 01.708 0z"/>
                                        </svg>
                                        Back
                                    </Button>
                                    <Button variant="primary" onClick={goToNextStep}>
                                        Continue
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" className="ms-2">
                                            <path fillRule="evenodd" d="M4.646 1.646a.5.5 0 01.708 0l6 6a.5.5 0 010 .708l-6 6a.5.5 0 01-.708-.708L10.293 8 4.646 2.354a.5.5 0 010-.708z"/>
                                        </svg>
                                    </Button>
                                </div>
                            </div>
                        )}

                        {/* ==================== STEP 3: Resources & Review ==================== */}
                        {currentStep === 3 && (
                            <div className="create-db-step-content">
                                <div className="step-title">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <rect x="2" y="3" width="20" height="14" rx="2" ry="2"/>
                                        <line x1="8" y1="21" x2="16" y2="21"/>
                                        <line x1="12" y1="17" x2="12" y2="21"/>
                                    </svg>
                                    Instance Size
                                </div>

                                {/* RAM Selection */}
                                <div className="resource-selector-group">
                                    <div className="resource-selector-header">
                                        <div className="resource-selector-label">
                                            <div className="resource-icon">
                                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                    <rect x="4" y="4" width="16" height="16" rx="2" ry="2"/>
                                                    <rect x="9" y="9" width="6" height="6"/>
                                                    <line x1="9" y1="1" x2="9" y2="4"/>
                                                    <line x1="15" y1="1" x2="15" y2="4"/>
                                                    <line x1="9" y1="20" x2="9" y2="23"/>
                                                    <line x1="15" y1="20" x2="15" y2="23"/>
                                                </svg>
                                            </div>
                                            <div>
                                                <span className="resource-name">Memory (RAM)</span>
                                                <span className="resource-desc">Allocate memory for your database</span>
                                            </div>
                                        </div>
                                        <div className="resource-selected-value">{formData.ramSize} GB</div>
                                    </div>
                                    <div className="resource-options">
                                        {ramSizes.map((size) => (
                                            <div
                                                key={size}
                                                className={`resource-option ${formData.ramSize === size ? "selected" : ""}`}
                                                onClick={() => setFormData((prev) => ({ ...prev, ramSize: size }))}
                                            >
                                                <span className="option-value">{size}</span>
                                                <span className="option-unit">GB</span>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                {/* CPU Selection */}
                                <div className="resource-selector-group">
                                    <div className="resource-selector-header">
                                        <div className="resource-selector-label">
                                            <div className="resource-icon cpu">
                                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                    <rect x="4" y="4" width="16" height="16" rx="2" ry="2"/>
                                                    <rect x="9" y="9" width="6" height="6"/>
                                                    <line x1="9" y1="1" x2="9" y2="4"/>
                                                    <line x1="15" y1="1" x2="15" y2="4"/>
                                                    <line x1="9" y1="20" x2="9" y2="23"/>
                                                    <line x1="15" y1="20" x2="15" y2="23"/>
                                                    <line x1="20" y1="9" x2="23" y2="9"/>
                                                    <line x1="20" y1="14" x2="23" y2="14"/>
                                                    <line x1="1" y1="9" x2="4" y2="9"/>
                                                    <line x1="1" y1="14" x2="4" y2="14"/>
                                                </svg>
                                            </div>
                                            <div>
                                                <span className="resource-name">vCPU Cores</span>
                                                <span className="resource-desc">Processing power for your workload</span>
                                            </div>
                                        </div>
                                        <div className="resource-selected-value">{formData.cpuCores} Cores</div>
                                    </div>
                                    <div className="resource-options">
                                        {cpuOptions.map((cores) => (
                                            <div
                                                key={cores}
                                                className={`resource-option ${formData.cpuCores === cores ? "selected" : ""}`}
                                                onClick={() => setFormData((prev) => ({ ...prev, cpuCores: cores }))}
                                            >
                                                <span className="option-value">{cores}</span>
                                                <span className="option-unit">Core{cores > 1 ? "s" : ""}</span>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                {/* Storage Selection */}
                                <div className="resource-selector-group">
                                    <div className="resource-selector-header">
                                        <div className="resource-selector-label">
                                            <div className="resource-icon storage">
                                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                    <line x1="22" y1="12" x2="2" y2="12"/>
                                                    <path d="M5.45 5.11L2 12v6a2 2 0 002 2h16a2 2 0 002-2v-6l-3.45-6.89A2 2 0 0016.76 4H7.24a2 2 0 00-1.79 1.11z"/>
                                                    <line x1="6" y1="16" x2="6.01" y2="16"/>
                                                    <line x1="10" y1="16" x2="10.01" y2="16"/>
                                                </svg>
                                            </div>
                                            <div>
                                                <span className="resource-name">Storage</span>
                                                <span className="resource-desc">SSD storage for your data</span>
                                            </div>
                                        </div>
                                        <div className="resource-selected-value">{formData.storageSize} GB</div>
                                    </div>
                                    <div className="resource-options storage-options">
                                        {storageSizes.map((size) => (
                                            <div
                                                key={size}
                                                className={`resource-option ${formData.storageSize === size ? "selected" : ""}`}
                                                onClick={() => setFormData((prev) => ({ ...prev, storageSize: size }))}
                                            >
                                                <span className="option-value">{size}</span>
                                                <span className="option-unit">GB</span>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                {/* Tags Section */}
                                <div className="step-title mt-4">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z"/>
                                        <line x1="7" y1="7" x2="7.01" y2="7"/>
                                    </svg>
                                    Tags (Optional)
                                </div>

                                <Row>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Environment</Form.Label>
                                            <Form.Select
                                                name="environment"
                                                value={formData.environment}
                                                onChange={handleInputChange}
                                            >
                                                <option value="development">Development</option>
                                                <option value="staging">Staging</option>
                                                <option value="production">Production</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Project Name</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="project"
                                                value={formData.project}
                                                onChange={handleInputChange}
                                                placeholder="e.g., my-app"
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                {/* Summary Section */}
                                <div className="create-db-summary">
                                    <div className="summary-title">Summary</div>
                                    <Row>
                                        <Col md={6}>
                                            <table className="summary-table">
                                                <tbody>
                                                    <tr>
                                                        <td>Engine</td>
                                                        <td><strong>{selectedDbType?.name} {formData.version}</strong></td>
                                                    </tr>
                                                    <tr>
                                                        <td>Instance Name</td>
                                                        <td><strong>{formData.name || "-"}</strong></td>
                                                    </tr>
                                                    <tr>
                                                        <td>Database</td>
                                                        <td><strong>{formData.dbName}</strong></td>
                                                    </tr>
                                                    <tr>
                                                        <td>Username</td>
                                                        <td><strong>{formData.dbUsername}</strong></td>
                                                    </tr>
                                                    <tr>
                                                        <td>Environment</td>
                                                        <td><strong style={{ textTransform: "capitalize" }}>{formData.environment}</strong></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </Col>
                                        <Col md={6}>
                                            <table className="summary-table">
                                                <tbody>
                                                    <tr>
                                                        <td>RAM</td>
                                                        <td><strong>{formData.ramSize} GB</strong></td>
                                                    </tr>
                                                    <tr>
                                                        <td>vCPU</td>
                                                        <td><strong>{formData.cpuCores} Cores</strong></td>
                                                    </tr>
                                                    <tr>
                                                        <td>Storage</td>
                                                        <td><strong>{formData.storageSize} GB</strong></td>
                                                    </tr>
                                                    <tr>
                                                        <td>Max Connections</td>
                                                        <td><strong>{formData.maxConnections}</strong></td>
                                                    </tr>
                                                    <tr>
                                                        <td>Port</td>
                                                        <td><strong>{formData.dbPort}</strong></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </Col>
                                    </Row>

                                    {/* Estimated Cost */}
                                    <div className="estimated-cost">
                                        <div className="cost-label">Estimated Cost</div>
                                        <div className="cost-values">
                                            <span className="cost-item">
                                                <strong>${estimatedCost.hourly}</strong>/hour
                                            </span>
                                            <span className="cost-divider">|</span>
                                            <span className="cost-item">
                                                <strong>${estimatedCost.monthly}</strong>/month
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div className="step-actions">
                                    <Button variant="outline-secondary" onClick={goToPrevStep}>
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" className="me-2">
                                            <path fillRule="evenodd" d="M11.354 1.646a.5.5 0 010 .708L5.707 8l5.647 5.646a.5.5 0 01-.708.708l-6-6a.5.5 0 010-.708l6-6a.5.5 0 01.708 0z"/>
                                        </svg>
                                        Back
                                    </Button>
                                    <Button
                                        variant="primary"
                                        type="submit"
                                        disabled={isSubmitting}
                                        className="deploy-btn"
                                    >
                                        {isSubmitting ? (
                                            <>
                                                <Spinner animation="border" size="sm" className="me-2" />
                                                Creating...
                                            </>
                                        ) : (
                                            <>
                                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="me-2">
                                                    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
                                                </svg>
                                                Deploy Database
                                            </>
                                        )}
                                    </Button>
                                </div>
                            </div>
                        )}
                    </Form>
                </div>
                </Container>
            </div>

            {/* Deployment Progress Modal */}
            <DeploymentProgressModal
                show={showDeploymentModal}
                onHide={() => setShowDeploymentModal(false)}
                databaseId={deployedDatabaseId}
                databaseName={formData.name}
                onComplete={handleDeploymentComplete}
                onViewDatabase={handleViewDatabase}
            />
        </div>
    );
}

export default CreateDatabase;
